"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ActionTypes = require("./actionTypes");
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    function openOverlay(mode, file) {
        switch (mode) {
            case 'NEW_FOLDER':
                return {
                    type: ActionTypes.OPEN_OVERLAY,
                    payload: { mode: 'NEW_FOLDER' }
                };
            case 'EDIT':
                if (file !== undefined) {
                    return {
                        type: ActionTypes.OPEN_OVERLAY,
                        payload: { mode: 'EDIT', file }
                    };
                }
                break;
            case 'EDIT_SUBPROJECT':
                if (file !== undefined) {
                    return {
                        type: ActionTypes.OPEN_OVERLAY,
                        payload: { mode: 'EDIT_SUBPROJECT', file }
                    };
                }
                break;
            case 'DELETE':
                return { type: ActionTypes.OPEN_OVERLAY, payload: { mode: 'DELETE' } };
            case 'TTL':
                return { type: ActionTypes.OPEN_OVERLAY, payload: { mode: 'TTL' } };
        }
        return { type: ActionTypes.OPEN_OVERLAY, payload: { mode: 'CLOSED' } };
    }
    function closeOverlay() {
        return {
            type: ActionTypes.CLOSE_OVERLAY,
            mode: 'CLOSED'
        };
    }
    function setNewFolderName(name) {
        return {
            type: ActionTypes.SET_NEW_FOLDER_NAME,
            name
        };
    }
    function setNewFolderDescription(description) {
        return {
            type: ActionTypes.SET_NEW_FOLDER_DESCRIPTION,
            description
        };
    }
    function editCustomMeta(value) {
        return {
            type: ActionTypes.EDIT_CUSTOM_META,
            payload: {
                value
            }
        };
    }
    function savePropertiesRequest(file, metadata, values, mode = 'EDIT') {
        return {
            type: ActionTypes.SAVE_PROPERTIES_REQUEST,
            payload: {
                file,
                metadata,
                values,
                mode
            }
        };
    }
    function savePropertiesSuccess(file) {
        return {
            type: ActionTypes.SAVE_PROPERTIES_SUCCESS,
            file
        };
    }
    function savePropertiesFailure(error) {
        return {
            type: ActionTypes.SAVE_PROPERTIES_FAILURE,
            payload: error
        };
    }
    function saveNewFolderRequest(name, parent, type, description) {
        return {
            type: ActionTypes.SAVE_NEW_FOLDER_REQUEST,
            payload: {
                name,
                parent,
                type,
                description
            }
        };
    }
    function saveNewFolderSuccess() {
        return {
            type: ActionTypes.SAVE_NEW_FOLDER_SUCCESS
        };
    }
    function saveNewFolderFailure(error) {
        return {
            type: ActionTypes.SAVE_NEW_FOLDER_FAILURE,
            payload: error
        };
    }
    function deleteRequest(files) {
        return {
            type: ActionTypes.DELETE_REQUEST,
            files
        };
    }
    function deleteSuccess(files) {
        return {
            type: ActionTypes.DELETE_SUCCESS,
            files
        };
    }
    function deleteFailure(error) {
        return {
            type: ActionTypes.DELETE_FAILURE,
            payload: error
        };
    }
    function validationFailure(errors) {
        return {
            type: ActionTypes.VALIDATION_FAILURE,
            payload: errors
        };
    }
    function getTTLRequest(folder) {
        return {
            type: ActionTypes.GET_TTL_REQUEST,
            folder
        };
    }
    function getTTLSuccess(ttl) {
        return {
            type: ActionTypes.GET_TTL_SUCCESS,
            ttl
        };
    }
    function getTTLFailure(error) {
        return {
            type: ActionTypes.GET_TTL_FAILURE,
            payload: error
        };
    }
    function setTTLRequest(folderUuid, ttl) {
        return {
            type: ActionTypes.SET_TTL_REQUEST,
            folderUuid,
            ttl
        };
    }
    function setTTLSuccess(ttl) {
        return {
            type: ActionTypes.SET_TTL_SUCCESS,
            ttl
        };
    }
    function setTTLFailure(error) {
        return {
            type: ActionTypes.SET_TTL_FAILURE,
            payload: error
        };
    }
    return {
        openOverlay,
        closeOverlay,
        setNewFolderName,
        setNewFolderDescription,
        editCustomMeta,
        savePropertiesRequest,
        savePropertiesSuccess,
        savePropertiesFailure,
        saveNewFolderRequest,
        saveNewFolderSuccess,
        saveNewFolderFailure,
        deleteRequest,
        deleteSuccess,
        deleteFailure,
        validationFailure,
        getTTLRequest,
        getTTLSuccess,
        getTTLFailure,
        setTTLRequest,
        setTTLSuccess,
        setTTLFailure
    };
}
exports.default = default_1;
//# sourceMappingURL=actions.js.map